import React, { Fragment, useCallback } from 'react';

import styles from './GameHeader.module.less';
import GameLink from '../../components/GameLink/GameLink';
import useLog from '../../utils/hooks/useLog';

export default ({ title, operate, to, change = () => {}, source }) => {
  const [report] = useLog();
  let more = null;

  const changeHandle = useCallback(() => {
    change();
    report('C', 'Game_Tab_Change', { source });
  }, [change]);

  if (operate === '2') {
    more = (
      <GameLink
        source={source}
        to={to}
        logInfo={{
          category: 'C',
          action: 'Game_New_More',
          params: {
            source,
          },
        }}
      >
        更多
      </GameLink>
    );
  } else if (operate === '1') {
    more = (
      <button onClick={changeHandle}>
        <img src={require('./change.png')} alt="" />
        换一换
      </button>
    );
  }

  return (
    <header className={styles.Header}>
      <h1>{title}</h1>
      {more}
    </header>
  );
};
